import { Routes, Route, useParams, useLocation, Navigate } from 'react-router-dom';
import { isReservedAdminRoute } from '@/utils/adminPaths';
import { getArenaSlug } from '@/utils/arena';
import authService from '@/services/authService';
import AdminLayout from '@/components/admin/AdminLayout';
import Dashboard from '@/pages/admin/Dashboard';
import BookingSchedule from '@/pages/admin/BookingSchedule';
import TransactionProduct from '@/components/admin/TransactionProduct';
import ScheduleView from '@/pages/admin/ScheduleView';
import ProductSell from '@/pages/ProductSell';
import FieldList from '@/pages/admin/FieldList';
import AddField from '@/pages/admin/AddField';
import EditField from '@/pages/admin/EditField';
import ServiceList from '@/pages/admin/ServiceList';
import OtherProductList from '@/pages/admin/OtherProductList';
import AddVoucher from '@/pages/admin/AddVoucher';
import EditVoucher from '@/pages/admin/EditVoucher';
import VoucherList from '@/pages/admin/VoucherList';
import ProfileSettings from '@/pages/admin/ProfileSettings';
import Wallet from '@/pages/admin/Wallet';
import WhatsappPage from './admin/Whatsapp';
import CustomerListPage from '@/pages/admin/customers/CustomerListPage';
import CustomerDetailPage from '@/pages/admin/customers/CustomerDetailPage';
import LoyaltyPage from '@/pages/admin/loyalty/LoyaltyPage';

const AdminPage = () => {
  const { slug } = useParams<{ slug?: string }>();
  const location = useLocation();

  if (slug && isReservedAdminRoute(slug)) {
    const realSlug = authService.getSlug() || getArenaSlug();
    if (realSlug) {
      const subpath = location.pathname.replace(/^\/admin/, '');
      return <Navigate to={`/admin/${realSlug}${subpath}`} replace />;
    }
  }

  if (!slug) {
    const realSlug = authService.getSlug() || getArenaSlug();
    if (realSlug) {
      return <Navigate to={`/admin/${realSlug}`} replace />;
    }
  }

  return (
    <Routes>
      <Route path="/" element={<AdminLayout arenaSlug={slug} />}>
        <Route index element={<Dashboard />} />

        <Route path="booking" element={<BookingSchedule />} />
        <Route path="transactions" element={<TransactionProduct />} />
        <Route path="field" element={<FieldList />} />

        <Route path="service" element={<ServiceList />} />

        <Route path="other-product" element={<OtherProductList />} />
        <Route path="voucher" element={<VoucherList />} />
        <Route path="voucher/create" element={<AddVoucher />} />
        <Route path="voucher/edit/:voucherCode" element={<EditVoucher />} />
        {/* <Route path="field/new" element={<FieldNew />} /> */}
        <Route path="field/add" element={<AddField />} />
        <Route path="field/edit/:slug" element={<EditField />} />
        <Route path="field/schedule/:slugField" element={<ScheduleView />} />
        <Route path="transaction/product-sell" element={<ProductSell />} />
        <Route path="profile-settings" element={ProfileSettings('admin')} />
        <Route path="customers" element={<CustomerListPage />} />
        <Route path="customers/:customerId" element={<CustomerDetailPage />} />
        <Route path="loyalty" element={<LoyaltyPage />} />
        <Route path="whatsapp" element={<WhatsappPage />} />
        <Route path="wallet" element={<Wallet />} />
      </Route>
    </Routes>
  );
};

export default AdminPage;
